import React from 'react'

const NotFound = () => {
    return (
        <div>Page NotFound</div>
    )
}

export default NotFound